import React from 'react';

export const YearModal = {
  title: 'Year',
  body: (
    <div>
      <p>
        Please see the caveat on
        {' '}
        <a href="https://www.ngdc.noaa.gov/hazard/tsunami-db-intro.html#uncertainty" target="_blank" rel="noopener noreferrer">
          uncertainties in the Significant Earthquake and Tsunami Databases
        </a>
        {' '}
        for more information on the completeness and accuracy of this database.
      </p>
    </div>
  ),
};
